const storage = 'localStorage' in window && window.localStorage !== null ? window.localStorage : null;
const prefix = 'smenadc';

export function saveInStorage(key: string, value: unknown) {
	if (!storage) {
		return;
	}
	if (value === null) storage.removeItem(`${prefix}-${key}`);
	else storage.setItem(`${prefix}-${key}`, JSON.stringify(value));
}

export function loadFromStorage<T>(key: string): T | null {
	const value = storage && storage.getItem(`${prefix}-${key}`);
	if (value) {
		return JSON.parse(value);
	}
	return null;
}

export function clearStorage() {
	if (storage) {
		storage.clear();
	}
}
